/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * 
 * @export
 * @interface RegisterCompanyResponse
 */
export interface RegisterCompanyResponse {
    /**
     * 
     * @type {Company}
     * @memberof RegisterCompanyResponse
     */
    data: Company;
}

/**
 * Check if a given object implements the RegisterCompanyResponse interface.
 */
export function instanceOfRegisterCompanyResponse(value: object): value is RegisterCompanyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RegisterCompanyResponseFromJSON(json: any): RegisterCompanyResponse {
    return RegisterCompanyResponseFromJSONTyped(json, false);
}

export function RegisterCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CompanyFromJSON(json['data']),
    };
}

  export function RegisterCompanyResponseToJSON(json: any): RegisterCompanyResponse {
      return RegisterCompanyResponseToJSONTyped(json, false);
  }

  export function RegisterCompanyResponseToJSONTyped(value?: RegisterCompanyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CompanyToJSON(value['data']),
    };
}

